import React, { useState } from 'react';
import {
  Box,
  Flex,
  IconButton,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  Image,
  useColorModeValue,
} from '@chakra-ui/react';
import { HamburgerIcon } from '@chakra-ui/icons';
import NavigationDrawer from './NavigationDrawer';
import RCLogo from './assets/footer-logo.png';
import UserProfile from './UserProfile';
import { useUser } from '../../../Context/User';
import { Link, useLocation } from 'react-router-dom';

const MainLayout = ({ children }) => {
  const { isLoggedIn, userInfo } = useUser();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const cardBg= useColorModeValue('rcBrand.parchment','rcBrand.forest');
  const borderColor = useColorModeValue('white', 'black');
  const pageBgColor = useColorModeValue("linear(to-b, rcBrand.parchment, white 50%)", "linear(to-b, black, rcBrand.forest 99%)");
  
  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const location = useLocation(); // Get the current route
  const hideHeaderFooter = location.pathname === '/login'; // Check if on the login page

  return (
    <Flex direction="column" minH="100vh">
      {/* Header */}
      {!hideHeaderFooter && (
        <Box
          bg="rcBrand.forest"
          color={borderColor}
          borderBottomColor={"black"}
          borderBottomWidth={1}
          p={{ base: 2, md: 3 }}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          boxShadow="0px 4px 6px rgba(0, 0, 0, 0.5)"
        >
          <Flex alignItems="center">
            {isLoggedIn && (
              <IconButton
                aria-label="Open Drawer"
                icon={<HamburgerIcon />}
                onClick={toggleDrawer}
                size="md"
                colorScheme="rcBrand"
                mr={5}
                _hover={{bg: 'rcBrand.evergreen'}}
              />
            )}
    <Link to="/">
  <Image 
    src={RCLogo} 
    alt="RC Logo" 
    height={{ base: '30px', md: '50px' }} // Adjust the height for different screen sizes
    width={{ base: '60px', md: '70px' }} // Set a wider width
    objectFit="contain" // Ensure the logo fits without being stretched

  />
</Link>
          </Flex>
          {isLoggedIn && <UserProfile userInfo={userInfo} />}
        </Box>
      )}

      {/* Content Area with Background Gradient */}
      <Box flex="1" bgGradient={pageBgColor} overflowY="auto">
        {children}
      </Box>

      {/* Navigation Drawer */}
      <Drawer placement="left" onClose={toggleDrawer} isOpen={isDrawerOpen} size="xs">
        <DrawerOverlay>
          <DrawerContent
            borderRadius="lg"
            bg={cardBg} 
            style={{ height: '75%', alignSelf: 'flex-start' }}
          >
            <DrawerCloseButton />
            <DrawerHeader fontSize="xl">Navigation</DrawerHeader>
            <DrawerBody>
              <NavigationDrawer />
              <Flex alignItems="center" justifyContent="space-between" mt="1rem" />
            </DrawerBody>
          </DrawerContent>
        </DrawerOverlay>
      </Drawer>

      {/* Footer */}
      {!hideHeaderFooter && (
        <Box
          bg="rcBrand.forest"
          color={borderColor}
          p={{ base: 2, md: 3 }}
          textAlign="center"
          boxShadow="0px -4px 6px rgba(0, 0, 0, 0.1)"
        >
          &copy; {new Date().getFullYear()} RideConnection NEMT App. All rights reserved.
          <br />
          <a>For support email</a>
          <a href="mailto:support@rideconnection.org">support@rideconnection.org</a>
        </Box>
      )}
    </Flex>
  );
};

export default MainLayout;
